module.exports = __webpack_public_path__ + "static/img/cont2201.7e31457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2201.jpg
// module id = Dn0P
// module chunks = 0